
export const MAC_DOWNLOAD = 'https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.1.1%28MacOS%29.zip'
export const WIN_DOWNLOAD = 'https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.1%28Windows%29.zip'

// 暂时不用
export const clickTypeMapper = {
    CEMETA_LOGIN: 'cemeta_login', // （官网）登录
    CEMETA_REGISTER: 'cemeta_register', // （官网）注册
    CEMETA_LOGOUT: 'cemeta_logout', // （官网）登出
    CEMETA_DOWNLOAD_MAC: 'cemeta_download_mac', //  （官网）Mac下载
    CEMETA_DOWNLOAD_WINDOWS: 'cemeta_download_windows', //  （官网）Windows下载
}